import { handleActions } from "redux-actions";
import { api } from "api";
import { NotificationManager } from "react-notifications";

const PARAMETRO = 'PARAMETRO';

export const listarVendedoresForComboBox = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split("/");
    let id = id_emp[5];
    const params = { id, search };
    return api
        .get("auto_ventas/vendedores", params)
        .then((response) => {
            let listaVendedores = [];
            if (response) {
                response.forEach((item) => {
                    listaVendedores.push({
                        value: item.id,
                        label: item.nombre,
                    });
                });
            }
            return listaVendedores;
        })
        .catch((error) => {
            return [];
        });
};

export const listadoDeIngresos = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split("/");
    let id = id_emp[5];
    const params = { id, search };
    return api
        .get(`auto_ventas/ingresos/listado_resumido`, params)
        .then((response) => {
            let autoList = [];
            response.forEach((item) => {
                autoList.push({
                    value: item.auto.value,
                    label: item.auto.label,
                });
            });
            return autoList;
        })
        .catch((error) => {
            NotificationManager.error(
                "Ocurrio un error al obtener los datos",
                "Error",
                2000,
                null,
                true
            );
            return [];
        });
};

export const reporteListadoDeVendedores = (data) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split("/");
    let id = id_emp[5];
    data.estado = data.estado.value;
    let rep = "listado_de_vendedores";
    const params = { id, rep, ...data };
    api.getPdf("/auto_ventas/vendedores/reportes", params)
        .then((response) => {
            if (response.headers["content-type"] == "application/pdf") {
                var blob = new Blob([response.text], {
                    type: "application/pdf;charset=utf-8",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "listado_de_vendedores.pdf";
                window.open(link, "_blank");
                return false;
            }
        })
        .catch((error) => {
            if (error.status === 404) {
                NotificationManager.info(error.body.msj, "Informacion", 5000);
            }
            if (error.status === 500) {
                NotificationManager.error(
                    "Ocurrió un error al generar reporte",
                    "Error",
                    2000
                );
            }
        });
};

export const reporteRecepcionDeVehiculos = (data) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split("/");
    let id = id_emp[5];
    let carroId = data.marca.value;
    let rep = "recepcion_de_vehiculos";
    const params = { id, rep, carroId };
    api.getPdf("/auto_ventas/ingresos/reportes", params)
        .then((response) => {
            if (response.headers["content-type"] == "application/pdf") {
                var blob = new Blob([response.text], {
                    type: "application/pdf;charset=utf-8",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "recepcion_de_vehiculos.pdf";
                window.open(link, "_blank");
                return false;
            }
        })
        .catch((error) => {
            if (error.status === 404) {
                NotificationManager.info(error.body.msj, "Informacion", 5000);
            }
            if (error.status === 500) {
                NotificationManager.error(
                    "Ocurrió un error al generar reporte",
                    "Error",
                    2000
                );
            }
        });
};

export const reporteListadoDeVehiculos = (data) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split("/");
    let id = id_emp[5];
    let estado = data.estado.value;
    let rep = "listado_vehiculos";
    const params = { id, rep, estado };
    api.getPdf("/auto_ventas/ingresos/reportes", params)
        .then((response) => {
            if (response.headers["content-type"] == "application/pdf") {
                var blob = new Blob([response.text], {
                    type: "application/pdf;charset=utf-8",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "listado_de_vehiculos.pdf";
                window.open(link, "_blank");
                return false;
            }
        })
        .catch((error) => {
            if (error.status === 404) {
                NotificationManager.info(error.body.msj, "Informacion", 5000);
            }
            if (error.status === 500) {
                NotificationManager.error(
                    "Ocurrió un error al generar reporte",
                    "Error",
                    2000
                );
            }
        });
};

export const reporteListadoDeVentas = (data) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split("/");
    let id = id_emp[5];
    if (data.vendedor) {
        data.vendedor = data.vendedor.value;
    } else {
        data.vendedor = "";
    }

    let rep = "listado_de_ventas";
    const params = { id, rep, ...data };
    api.getPdf("/auto_ventas/ventas/reportes", params)
        .then((response) => {
            if (response.headers["content-type"] == "application/pdf") {
                var blob = new Blob([response.text], {
                    type: "application/pdf;charset=utf-8",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "listado_de_ventas.pdf";
                window.open(link, "_blank");
                return false;
            }
        })
        .catch((error) => {
            if (error.status === 404) {
                NotificationManager.info(error.body.msj, "Informacion", 5000);
            }
            if (error.status === 500) {
                NotificationManager.error(
                    "Ocurrió un error al generar reporte",
                    "Error",
                    2000
                );
            }
        });
};

export const reporteCostos = (data) => () => {
    let ruta = window.location.href;
    console.log(data)
    let id_emp = ruta.split("/");
    let id = id_emp[5];
    let estado = data.estado.value;
    let idVehiculo = data.vehiculo ? data.vehiculo.value : '';
    let rep = "listado_de_costos";
    const params = { id, rep, estado, idVehiculo};
    api.getPdf("/auto_ventas/otro_gasto/", params)
        .then((response) => {
            if (response.headers["content-type"] == "application/pdf") {
                var blob = new Blob([response.text], {
                    type: "application/pdf;charset=utf-8",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "listado_de_costos.pdf";
                window.open(link, "_blank");
                return false;
            }
        })
        .catch((error) => {
            if (error.status === 404) {
                NotificationManager.info(error.body.msj, "Informacion", 5000);
            }
            if (error.status === 500) {
                NotificationManager.error(
                    "Ocurrió un error al generar reporte",
                    "Error",
                    2000
                );
            }
        });
};

export const parametrosEmpresa = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id}
    api.get('/empresa/empresa_parametros', params).then((response) => {
        dispatch({type: PARAMETRO, datos: response });
    }).catch(()=>{
        NotificationManager.error(
            'Ocurrió un error al consultar parametros',
            'Error',
            8000
        );
    })
}

export const listarVehiculos = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split("/");
    let id = id_emp[5];
    const params = { id, search };
    return api
        .get("auto_ventas/ingresos/vehiculos_costo_reporte", params)
        .then((response) => {
            console.log(response)
            let listaVehiculo = [];
            if (response) {
                response.forEach((item) => {
                    listaVehiculo.push({
                        value: item.id,
                        label: item.codigo + ' / ' + item.placa + ' / ' + item.marca + ' / ' + item.linea + ' / ' + item.tipo_carro + ' / ' + item.color,
                    });
                });
            }
            return listaVehiculo;
        })
        .catch((error) => {
            return [];
        });
};


export const actions = {
    listadoDeIngresos,
    reporteListadoDeVehiculos,
    reporteRecepcionDeVehiculos,
    reporteListadoDeVentas,
    listarVendedoresForComboBox,
    reporteListadoDeVendedores,
    reporteCostos,
    parametrosEmpresa,
    listarVehiculos
};

export const reducers = {
    [PARAMETRO]: (state, { datos }) => {
        return {
            ...state,
            datos,
        };
    },
};

export const initialState = {
    datos: []
};

export default handleActions(reducers, initialState);
